import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DropdownField } from '../../../models/Field';

@Component({
  selector: 'dropdown-kendo',
  template: `<div [formGroup]="form" class="form-group">
    <label [attr.for]="fieldKey">{{ field.label }}</label>
    <input
      [formControlName]="field.key"
      type="hidden"
      id="{{ field.key + '-hidden' }}"
    />
    <div
      class="form-control custom-kendo"
      [style.width]="field.size ? field.size + 'em' : ''"
      style="max-width: 100%;"
      [ngClass]="
        control.invalid && control.touched ? 'ng-invalid ng-touched' : ''
      "
      id="{{ field.key + '-kendo' }}"
    ></div>
    <error-box [form]="form" [field]="field"></error-box>
  </div>`,
})
export class DropdownKendoComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() field: DropdownField;

  formStatusChangeSubscription;

  get control() {
    return this.form.controls[this.field.key];
  }

  ngOnInit() {
    this.formStatusChangeSubscription = this.form.statusChanges.subscribe(
      () => {
        const kendoComponent = $(`#${this.field.key}-kendo`).data(
          'kendoDropDownList'
        );
        if (kendoComponent) {
          kendoComponent.enable(!this.form.disabled);
        }
      }
    );
  }

  // ngOnChanges() {
  //   const kendoComponent = $(`#${this.field.key}-kendo`).data(
  //     'kendoDropDownList'
  //   );
  //   if (kendoComponent) {
  //     kendoComponent.enable(false);
  //   }
  // }

  ngAfterViewInit() {
    $(`#${this.field.key}-kendo`)
      .kendoDropDownList({
        value: this.control.value,
        optionLabel: this.field.placeholder || 'Select item',
        optionLabelTemplate: `<span class="text-muted">${
          this.field.placeholder || 'Select item'
        }</span>`,
        dataTextField: 'label',
        dataValueField: 'value',
        template: this.field.images
          ? '<span class="k-state-default" style="vertical-align: top; display: inline-block; width: 25px; height: 25px; background: center / contain no-repeat url(\'https://previews.123rf.com/images/aquir/aquir1311/aquir131100316/23569861-sample-grunge-red-round-stamp.jpg\');"></span><span class="k-state-default" style="display: inline-block; padding-left: 15px; line-height: 25px; color: black;">#: data.label #</span></span>'
          : undefined,
        valueTemplate: this.field.images
          ? '<span class="selected-value" style="display: block; vertical-align: top;"><span style=" display: inline-block; width: 15px; height: 15px; background: center / contain no-repeat url(\'https://previews.123rf.com/images/aquir/aquir1311/aquir131100316/23569861-sample-grunge-red-round-stamp.jpg\');"></span><span style="display: inline-block; padding-left: 5px; line-height: 15px; color: black;">#:data.label#</span></span>'
          : undefined,

        dataSource: this.field.items,
        change: ((evt) => {
          const value = evt.sender.value();
          this.form.controls[`${this.field.key}`].setValue(value);
          this.form.controls[`${this.field.key}`].markAsTouched();
          this.control.markAsTouched();
          this.control.markAsDirty();
        }).bind(this),
      })
      .data('kendoDropDownList');

    $(`#${this.field.key}-kendo`)
      .blur((evt) => {
        this.form.controls[`${this.field.key}`].markAsTouched();
      })
      .bind(this);

      this.control.valueChanges.subscribe(() => {
        var kendoDropdownlist = $(`#${this.field.key}-kendo`).data("kendoDropDownList");
        kendoDropdownlist.value(this.control.value);
      })
  }

  ngOnDestroy() {
    this.formStatusChangeSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/dropdown/dropdown-kendo.component.ts